import { JSX, PropsWithChildren } from "react"
import classNames from "classnames"
import styled from "styled-components"

import { UITypes } from "types"

import { Breadcrumbs } from "../Breadcrumbs"

import styles from "./index.module.scss"

const FlexHeightContainer = styled.div<{ maxHeight?: string }>`
  display: flex;
  flex-direction: column;
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight}` : ``)}
`

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`

interface Props extends PropsWithChildren {
  title?: string
  breadcrumbs?: UITypes.Breadcrumb[]
  className?: string
  offsetHeight?: string
  renderHeaderAccessoryView?: () => JSX.Element
}

export const ContentWrapper = ({
  title,
  children,
  breadcrumbs,
  className,
  offsetHeight,
  renderHeaderAccessoryView,
}: Props) => {
  return (
    <FlexHeightContainer
      maxHeight={`calc(100vh - 88px - ${offsetHeight || "0px"})`}
      className={classNames(styles.contentWrapper, className)}
    >
      {breadcrumbs && <Breadcrumbs list={breadcrumbs} />}
      <FlexContainer>
        <h2 className={styles.contentTitle}>{title}</h2>
        {renderHeaderAccessoryView?.()}
      </FlexContainer>
      {children}
    </FlexHeightContainer>
  )
}
